import api from './api';

export interface DailyLog {
  id: string;
  user_id: string;
  stream_id: string;
  date: string;
  hours_studied: number;
  topics_covered: string[];
  resources_used: string[];
  notes?: string;
  confidence_score: number;
  mood_energy: number;
  created_at: string;
  updated_at?: string;
}

export interface CreateLogData {
  stream_id: string;
  date: string;
  hours_studied?: number;
  topics_covered?: string[];
  resources_used?: string[];
  notes?: string;
  confidence_score?: number;
  mood_energy?: number;
}

export const logsService = {
  async getAll(streamId?: string, startDate?: string, endDate?: string): Promise<DailyLog[]> {
    const params = new URLSearchParams();
    if (streamId) params.append('stream_id', streamId);
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const response = await api.get(`/api/logs?${params.toString()}`);
    return response.data;
  },

  async getById(id: string): Promise<DailyLog> {
    const response = await api.get(`/api/logs/${id}`);
    return response.data;
  },

  async create(data: CreateLogData): Promise<DailyLog> {
    const response = await api.post('/api/logs', data);
    return response.data;
  },

  async update(id: string, data: Partial<DailyLog>): Promise<DailyLog> {
    const response = await api.patch(`/api/logs/${id}`, data);
    return response.data;
  },
};

